<div class="ag-theme-alpine" style="width: 100%;">
    <ag-grid-angular class="ag-theme-alpine compact-centered" style=" width:100%;" [rowData]="rows"
        [pinnedBottomRowData]="pinnedBottomRows"
        [columnDefs]="columns" [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions" domLayout="autoHeight" (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        (cellClicked)="onCellClicked($event)"
        [enableRangeSelection]="false"
        [suppressRowClickSelection]="true"

        >
    </ag-grid-angular>
</div>
<!-- [defaultColDef]="defaultColDef"
  [getRowId]="getRowId"
  [theme]="'legacy'" -->